import React from "react";
import { useTranslation } from "react-i18next";
import { GoalShareIcon } from "@/apps/goals/assets/icons";
import Button from "@/ui/Button/Button";
import cls from "./styles.module.scss";

interface ShareButtonProps {
  variant?: "graphite" | "primary";
  onClick: React.MouseEventHandler<HTMLButtonElement>;
}

export const ShareButton = ({
  variant = "primary",
  onClick,
}: ShareButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant={variant}
      className={cls.button}
      icon={<GoalShareIcon />}
      iconClassName={cls.icon}
      iconPosition="right"
      label={t("goals.common.share")}
      onClick={onClick}
    />
  );
};
